import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/400W_Hyundai.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Q_CELLS_Data_sheet_Q.PEAK_DUO_L-G7.2_385-405_2019-08_Rev02_AU" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/Hyundai400W.js